var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"}},[_vm._v("Reset")])}
var staticRenderFns = []

export { render, staticRenderFns }